import * as React from 'react'

import { Button } from '../../Button/Button'

import styles from './ButtonCard.module.css'

type ButtonCardProps = {
  heading: string
  content: string
  label: string
  size: 'big' | 'small'
}

const ButtonCard: React.FC<ButtonCardProps> = ({
  heading,
  content,
  label,
  size,
}) => {
  const showBigButton = size === 'big'

  return (
    <div className={styles[`buttonCardContainer-${size}`]}>
      <div>
        <h3 className={styles[`contentHeading-${size}`]}>{heading}</h3>
        <p className={styles[`contentDetail-${size}`]}>{content}</p>
      </div>
      {showBigButton ? (
        <div className={styles.buttonWrapper}>
          <Button type="primary" size="large">
            {label}
          </Button>
        </div>
      ) : (
        <Button type="primary" size="xsmall">
          {label}
        </Button>
      )}
    </div>
  )
}

export default ButtonCard
